"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMX = void 0;
const types_1 = require("../types");
exports.IMX = {
    [types_1.Networks.Ropsten]: '0x6659a9c5cd313974343e30b4fdffd95bd4b4dcd2',
    [types_1.Networks.Mainnet]: '0x7b35ce522cb72e4077baeb96cb923a5529764a00',
    [types_1.Networks.Polygon]: '0x60bb3d364b765c497c8ce50ae0ae3f0882c5bd05',
    [types_1.Networks.Arbitrum]: '0x9c67ee39e3c4954396b9142010653f17257dd39c',
    [types_1.Networks.Avalanche]: '0xea6887e4a9cda1b77e70129e5fba830cdb5cddef',
    [types_1.Networks.Moonriver]: '0x900f1Ec5819FA087d368877cD03B265Bf1802667',
    [types_1.Networks.Aurora]: '',
    [types_1.Networks.Cronos]: '',
    [types_1.Networks.Fantom]: '0xea38f1ccf77bf43f352636241b05dd8f6f5f52b2',
    [types_1.Networks.Harmony]: '0xbd8064cdb96c00a73540922504f989c64b7b8b96',
    [types_1.Networks.Moonbeam]: '',
    [types_1.Networks.Sxnetwork]: '',
    [types_1.Networks.Canto]: '',
    [types_1.Networks.ZksyncEra]: '',
    [types_1.Networks.Blast]: '',
    [types_1.Networks.Base]: '',
    [types_1.Networks.Mantle]: '',
    [types_1.Networks.Scroll]: '',
    [types_1.Networks.Optimism]: '',
    [types_1.Networks.Real]: '',
    [types_1.Networks.Sonic]: '',
    [types_1.Networks.Linea]: '',
};
